export const FETCH_HOME_TABLE_START = "FETCH_HOME_TABLE_START";
export const FETCH_HOME_TABLE_SUCCESS = "FETCH_HOME_TABLE_SUCCESS";
export const FETCH_HOME_TABLE_FAIL = "FETCH_HOME_TABLE_FAIL";
